import { Lightbulb, AlertTriangle, CheckCircle2, Info } from "lucide-react";
import type { ReactNode } from "react";

type Variant = "tip" | "warning" | "check" | "info";

const config: Record<
  Variant,
  { icon: typeof Lightbulb; ring: string; bg: string; iconBg: string; iconText: string }
> = {
  tip: {
    icon: Lightbulb,
    ring: "border-amber-200/70",
    bg: "bg-amber-50/70",
    iconBg: "bg-amber-100",
    iconText: "text-amber-700",
  },
  warning: {
    icon: AlertTriangle,
    ring: "border-orange-200/70",
    bg: "bg-orange-50/70",
    iconBg: "bg-orange-100",
    iconText: "text-orange-700",
  },
  check: {
    icon: CheckCircle2,
    ring: "border-primary/25",
    bg: "bg-primary/[0.06]",
    iconBg: "bg-primary/15",
    iconText: "text-primary",
  },
  info: {
    icon: Info,
    ring: "border-sky-200/70",
    bg: "bg-sky-50/70",
    iconBg: "bg-sky-100",
    iconText: "text-sky-700",
  },
};

export const Callout = ({
  variant = "tip",
  title,
  children,
}: {
  variant?: Variant;
  title?: string;
  children: ReactNode;
}) => {
  const c = config[variant];
  const Icon = c.icon;
  return (
    <div className={`not-prose my-5 rounded-2xl border ${c.ring} ${c.bg} p-4 sm:p-5 flex gap-3 ${title ? "items-start" : "items-center"}`}>
      <span
        className={`flex-shrink-0 w-9 h-9 rounded-xl ${c.iconBg} ${c.iconText} flex items-center justify-center`}
      >
        <Icon className="w-4 h-4" strokeWidth={2.5} />
      </span>
      <div className="text-[13.5px] sm:text-[15px] leading-relaxed text-foreground/90 min-w-0 flex-1">
        {title && <p className="font-bold mb-1 text-foreground">{title}</p>}
        <div className="space-y-2">{children}</div>
      </div>
    </div>
  );
};
